import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as moment from 'jalali-moment';

import Routes from "./Routes";
import { setInterceptors } from "./services";
import { theme, GlobalStyles, Fonts } from "./theme";
import { WalletProvider } from "./store";

function App() {
  setInterceptors();
  moment.locale('fa');

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Fonts />
      <ToastContainer />
      <WalletProvider>
        <Routes />
      </WalletProvider>
    </ThemeProvider>
  );
}

export default App;
